import { api } from '~shared/api/origin';

type TShardResponse = {
	shard: string;
	key: string;
	ttl: number;
};

export const shardsApi = api.injectEndpoints({
	endpoints: (build) => ({
		getShard: build.query<
			TShardResponse,
			{ id: string; params?: Record<string, string> }
		>({
			query: ({ id, params }) => ({
				url: `/shards/${id}`,
				params,
			}),
		}),
	}),
});
